import React from "react";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";
import { WhatsAppButton } from "@/components/WhatsAppFab";
import { WA_MESSAGES } from "@/lib/site";
import { Zap, ShieldCheck, Database, Filter, Download, Bell } from "lucide-react";

const REASONS = [
  { icon: Zap, t: "Daily freshness", d: "New MCA and GST registrations are uploaded every day — no month-old dumps." },
  { icon: Filter, t: "Precision filters", d: "Pan India, state-wise, city-wise, district-wise or ROC-wise — buy only what you need." },
  { icon: Database, t: "Clean CSV", d: "Standardised columns, importable into any CRM, spreadsheet or dialer." },
  { icon: ShieldCheck, t: "Public-record based", d: "We work with data from official ROC and GSTN filings — not scraped social profiles." },
  { icon: Download, t: "Simple downloads", d: "Full file or filtered slice, downloadable directly from your dashboard." },
  { icon: Bell, t: "Instant alerts", d: "Email notifications and in-app badges the moment a new file lands." },
];

export default function WhyRegistryFeed() {
  const path = "/why-registryfeed";
  const title = "Why Registry Feed | India's Daily Company Registry Feed";
  const description = "Why choose Registry Feed for your MCA and GST company database — daily freshness, precision filters, clean CSV, public-record sourcing, simple pricing.";
  const bc = [{ name: "Home", path: "/" }, { name: "Why Registry Feed", path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 py-14 sm:py-20">
        <div className="max-w-3xl">
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">Why Registry Feed?</h1>
          <p className="mt-4 text-muted-foreground text-base sm:text-lg">The reasons B2B teams pick us over generic list vendors.</p>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {REASONS.map((r) => (
            <div key={r.t} className="rounded-lg border border-border bg-card p-5">
              <div className="h-9 w-9 rounded-md bg-primary/10 text-primary grid place-items-center">
                <r.icon className="h-5 w-5" strokeWidth={1.75} />
              </div>
              <div className="mt-4 font-heading font-semibold">{r.t}</div>
              <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{r.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-10"><WhatsAppButton message={WA_MESSAGES.general} label="Start on WhatsApp" /></div>
      </section>
    </PublicPageLayout>
  );
}
